import A11yPopupButton from 'a11y/modules/a11y-popup-button'

export default class Menu {
  constructor(element) {
    this.trigger = element

    const targetId = this.trigger.getAttribute('aria-controls')
    this.target = document.getElementById(targetId)

    this.parentMenu = this.trigger.parentNode.closest('ul')

    this.instance = new A11yPopupButton(this.trigger)
    this.instance.init()

    window.addEventListener('A11yPopupOpen', ({ detail: { A11yPopup } }) => {
      if (
        A11yPopup.parentMenu == this.parentMenu &&
        this.trigger != A11yPopup.controller.node &&
        this.target != A11yPopup.node
      ) {
        this.instance.closePopup(false)
      }
    })
  }
}
